// Translation keys that carry a notification-signup block's body, highest precedence first.
// `description` is the key the builder writes; `body_text` is read as a fallback key.
export const SIGNUP_BODY_KEYS = ['description', 'body_text'] as const;

export type SignupBodyKey = (typeof SIGNUP_BODY_KEYS)[number];

// Resolves one locale's body: the first key with non-empty text wins.
export const resolveSignupBody = (readKey: (key: SignupBodyKey) => string | undefined): string =>
  SIGNUP_BODY_KEYS.map(readKey).find(Boolean) ?? '';
